import { render, staticRenderFns } from "./EmergenceForm.vue?vue&type=template&id=0fbc04d6&scoped=true&"
import script from "./EmergenceForm.vue?vue&type=script&lang=js&"
export * from "./EmergenceForm.vue?vue&type=script&lang=js&"
import style0 from "./EmergenceForm.vue?vue&type=style&index=0&id=0fbc04d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc04d6",
  null
  
)

export default component.exports